import { takeLeading, put, all, call } from "redux-saga/effects";
import SignUpActionTypes from "./signUp.types";
import { userSignupSuccess, userSignupFailure } from "./signUp.actions";
import AppConfig from "../../config/app.config";
import UserService from "../../services/user/user.service";
import { log } from "../../helpers/core.helper";

/** performs user signup */
export function* signupUser({ payload }) {
  try {
    const signUpData = {
      userName: payload.name,
      email: payload.email,
      password: payload.password,
      confirmPassword: payload.confirmPassword,
      // phone: payload.phone,
      subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
      verticalId: AppConfig.API.VERTICAL_ID,
      appId: AppConfig.API.APP_ID,
      // verificationId: "Number",
      // otp: "Number",
    };

    const res = yield UserService.signUp(signUpData);
    if (res.error != null) {
      yield put(
        userSignupFailure({
          signUpSuccess: false,
          loading: false,
          err: res.error.response.data.message,
        })
      );
    } else {
      if (res["status"]) {
        yield put(userSignupSuccess({ signUpSuccess: true, loading: true }));
      } else {
        yield put(
          userSignupFailure({
            signUpSuccess: false,
            loading: false,
            err: res["message"],
          })
        );
      }
    }
  } catch (err) {
    yield put(
      userSignupFailure({ signUpSuccess: false, loading: false, err: err })
    );
    log("signUp.sagas", "signupUser", err);
  }
}

/** Saga for user signup */
export function* userSignup() {
  yield takeLeading(SignUpActionTypes.SIGNUP_START, signupUser);
}
/**
 * Initialise all local sagas
 */
export function* signUpSagas() {
  yield all([call(userSignup)]);
}
